import { render } from "./content.vue?vue&type=template&id=d6695bce&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"

import "./content.vue?vue&type=style&index=0&id=d6695bce&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6695bce"]])